import { URLS } from '@/router/routes/urlRoutes'
import { MOBILE_URLS } from '@/router/routes/urlMobileRoutes'
import { getCurrentInstance } from 'vue'
import { Dictionary } from 'vue-router/types/router'

export interface Route {
  path?: string
  name: string | null
  hash?: string
  query?: Dictionary<string | (string | null)[]>
  params?: Dictionary<string>
  fullPath?: string
  redirectedFrom?: string
  meta?: any
}

export default function useRouter() {
  const instance = getCurrentInstance()
  const router = instance?.proxy.$router // Acceder a la instancia del router de Vue 2.7
  const route = instance?.proxy.$route

  function goBack() {
    router?.go(-1)
  }

  function goToRoute({ name, params = {}, path }: Route) {
    console.log('goToRoute', { name, params, path })
    if (router?.currentRoute.name === name || name == null) {
      return
    }
    console.log('Navigating to route', name)
    router?.push({
      name: name ?? undefined,
      path,
      params
    })
  }

  function goToRouteWithQuery({
    name,
    params = {},
    query = {}
  }: {
    name: string
    params?: Dictionary<string>
    query?: Dictionary<string>
  }) {
    router?.push({
      name,
      params,
      query
    })
  }

  function resolveRoute({ name, params = {} }: Partial<Route>) {
    return router?.resolve({
      name: name ?? undefined,
      params
    })
  }

  function resolveQueryRoute({ name, query = {} }: Route) {
    return router?.resolve({
      name: name ?? undefined,
      query
    })
  }

  function openRouteInNewWindow({ name, params = {} }: Route): void {
    window.open(resolveRoute({ name, params })?.href, '_blank')
  }

  function goToDashboard() {
    router?.push({
      name: URLS.DASHBOARD
    })
  }

  function goToLogin() {
    if (route?.name === URLS.LOGIN) {
      return
    }

    router?.push({
      name: URLS.LOGIN
    })
  }

  function goToMobile() {
    router?.push({
      name: MOBILE_URLS.EXPEDIENTS
    })
  }

  function goToLogout() {
    if (route?.name === URLS.LOGOUT) {
      return
    }
    router?.push({
      name: URLS.LOGOUT
    })
  }

  return {
    goBack,
    goToRoute,
    goToLogin,
    goToLogout,
    goToMobile,
    goToRouteWithQuery,
    router,
    route,
    resolveRoute,
    resolveQueryRoute,
    openRouteInNewWindow,
    goToDashboard
  }
}
